import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { combineLatest, Subscription } from 'rxjs';
import { Alarm } from 'src/app/_models/alarm';
import { EflResult } from 'src/app/_models/efl-results';
import { TopologyConfig, TopologyList, TopologyWithRoot } from 'src/app/_models/topology-list';
import { ApplicationsResultsService } from 'src/app/_services/applications-results-service/applications-results.service';
import { CommunicationService } from 'src/app/_services/communication-service/communication.service';

@Component({
  selector: 'app-alarms-menu',
  templateUrl: './alarms-menu.component.html',
  styleUrls: ['./alarms-menu.component.css']
})
export class AlarmsMenuComponent implements OnInit {

  public isSidebarOpen: boolean;
  public distinctTopologyIds: Array<string> = new Array<string>();
  public alarms: Array<Alarm> = new Array<Alarm>();
  public selectedTopologyId: string;

  filteredAlarms: Array<Alarm> = new Array<Alarm>();

  subscription: Subscription;

  constructor(
    private applicationsResultsService: ApplicationsResultsService,
    private route: ActivatedRoute,
    private communicationService: CommunicationService,
    private router: Router
  ) { }

  isSearching: boolean[] = Array(6).fill(false);
  searchText: string[] = Array(6).fill('');
  @ViewChild('searchInput', { static: false}) searchInputRef! : ElementRef;
  private shouldFocusInput = false;

  public selectedTopologyMap: Map<string, string> = new Map<string, string>();
  public topologies: TopologyList;

  ngOnInit() {
    this.applicationsResultsService.setSidebarOpen(true);
    this.isSidebarOpen = this.applicationsResultsService.getSidebarOpen();

    this.topologies = JSON.parse(localStorage.getItem("topologies"));
    // console.log('Topology Map', this.selectedTopologyMap);

    this.subscription = this.applicationsResultsService.alarms$.subscribe(alarms => {
      this.alarms = alarms;
    })

    this.getTopologyDisplayName();

    // console.log("Here are the alarms: ", this.alarms);

    // this.filterAlarmsByTopologyId(this.selectedTopologyId);
  }

  getTopologyDisplayName(): void {
    this.alarms.forEach((alarm : Alarm) => {
      if(alarm.topologyId){
        this.topologies.topologiesWithRoots.forEach((topologyWithRoot: TopologyWithRoot) => {
          if(alarm.topologyId === topologyWithRoot.TopologyId){
            alarm.topologyId = topologyWithRoot.displayName
          }
        })
      }else{
        alarm.topologyId = "No Topology ID";
      }
    })
  }

  sortTable(columnIndex: number): void {
    const table = document.getElementById("sortableTable");
    if (!table) return;

    const rows = Array.from((table as HTMLTableElement).rows).slice(1); // Skip header
    let isAscending = table.getAttribute("data-sort-order") === "asc";

    const parseDateToTimestamp = (value: string): number => {
      const trimmed = value.trim();
      const date = new Date(trimmed);
      return isNaN(date.getTime()) ? Infinity : date.getTime();
    };

    const sampleSize = Math.min(5, rows.length);
    const isDate = rows.slice(0, sampleSize).some(row => {
      const value = row.cells[columnIndex].innerText.trim();
      if (
        value === '' ||
        value.toLowerCase() === 'n/a' ||
        !/[\/\-:,]/.test(value)
      ) {
        return false;
      }
      const date = new Date(value);
      return !isNaN(date.getTime());
    });
    const isNumeric = rows.some(row => {
      const value = row.cells[columnIndex].innerText.trim();
      return !isNaN(parseFloat(value)) && value !== '' && value !== 'N/A' && value !== 'n/a';
    });

    rows.sort((rowA, rowB) => {
      const cellA = rowA.cells[columnIndex].innerText.trim() || '';
      const cellB = rowB.cells[columnIndex].innerText.trim() || '';

      if (isDate) {
        const dateA = parseDateToTimestamp(cellA);
        const dateB = parseDateToTimestamp(cellB);
        // console.log("Date sorting");
        return isAscending ? dateA - dateB : dateB - dateA;
      }


      if (isNumeric) {
        const numbA = (cellA === 'N/A' || cellA === '' || isNaN(parseFloat(cellA))) ? Infinity : parseFloat(cellA);
        const numbB = (cellB === 'N/A' || cellB === '' || isNaN(parseFloat(cellB))) ? Infinity : parseFloat(cellB);

        // console.error("Numeric sorting");
        return isAscending ? numbA - numbB : numbB - numbA;
      }

      return isAscending ? cellA.localeCompare(cellB) : cellB.localeCompare(cellA);
    });
    table.setAttribute("data-sort-order", isAscending ? "desc" : "asc");
    rows.forEach(row => table.appendChild(row));
  }

  toggleSearch(index: number): void {
    this.isSearching = this.isSearching.map((_, i) => i === index ? !this.isSearching[i] : false);

    if(this.isSearching.every(value => value === false)){
      this.searchText = Array(6).fill('');
    }
    console.log("Search Toggled:", this.isSearching);

    if(this.isSearching[index]){
      this.shouldFocusInput = true;
    }
  }

  filteredAlarmsByTopologyId(): any[] {
    if(this.isSearching.every(value => value === false)){
      this.searchText = Array(6).fill('');
    }
    if(this.searchText.every(text => !text)){
      return this.alarms;
    }

    return this.alarms.filter(alarm => {
      return this.searchText.every((text, index) => {
        if(!text) return true;
        const value = Object.values(alarm)[index];
        console.log("This is the output: ", value, "  ", index);
        return value.toString().toLowerCase().includes(text.toLowerCase());
      })
    })
  }

  jumpToTheTopology(topologyId: string){

    console.log("TOpologies that we hav e: ", this.topologies);

    const topology = this.topologies.topologiesWithRoots.find(
      (t: TopologyWithRoot) => t.displayName === topologyId
    );
    
    if (!topology) {
      throw new Error(`Topology with displayName "${topologyId}" not found`);
    }
    
    const topologyIdToJump = topology.TopologyId;

    if(topologyIdToJump){
      this.applicationsResultsService.getEflDataForTopology(topologyIdToJump).subscribe((eflResults: Array<EflResult>) => {
        console.log("Here is the correct toplogyID: ", topologyIdToJump);
        console.log("Here is the response: ", eflResults);
        this.applicationsResultsService.setEflResults(eflResults);
      });
    }

    this.topologies.topologiesWithRoots.forEach((topology: TopologyWithRoot) => {
      if(topology.displayName == topologyId || topology.internalDsoId + " - " + topology.TopologyId === topologyId){
        console.log("Just to the topology: ", topology.TopologyId);
        let topologyConfig: TopologyConfig = new TopologyConfig(
          topology.TopologyId,
          topology.latitude,
          topology.longitude,
          topology.lastTopologyChange
        );

        this.router.navigate(['home']);
        this.communicationService.setTopologyId(topologyConfig);
      }
    })
  }

  ngAfterViewChecked(){
    if(this.shouldFocusInput && this.searchInputRef){
      this.searchInputRef.nativeElement.focus();
      this.shouldFocusInput = false;
    }
  }

  ngOnDestroy(){
    this.subscription.unsubscribe();
  }

  resetDefaultTopology(){
    this.communicationService.setTopologyId(null);
  }

}
